import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';
import { DataLayer } from '@alfa-bank/site-data-layer/';

import type { IDependencies, TCard } from '../models';
import { PROMO_CARD_WIDTH, PROMO_CARD_HEIGHT } from '../config';
import { PromoCardV2 as Component } from '../promo-card-v2';

import styles from './desktop.css';

export const PromoCardDesktopV2 = createWidget<IDependencies, TCard>({
    Block,
    useNamedContainers,
    styles,
    defaultWidth: PROMO_CARD_WIDTH,
    defaultHeight: PROMO_CARD_HEIGHT,
    DataLayer,
    type: 'desktop',
})(Component);
